import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import useDialogFocus from '../hooks/useDialogFocus';

/**
 * Asks before something that cannot be undone (deleting a step, a photo).
 *
 * Focus starts on Cancel, so a hurried Enter never deletes anything; Escape
 * and a click outside cancel too. The confirm button names the action
 * ("Delete step"), never a bare "OK".
 */
export default function ConfirmDialog({
  title,
  children,
  confirmLabel,
  cancelLabel,
  danger = true,
  busy = false,
  onConfirm,
  onCancel,
}) {
  const { t } = useTranslation();
  const cancelRef = useRef(null);
  const dialogRef = useRef(null);

  useDialogFocus(dialogRef, { initialRef: cancelRef, onEscape: onCancel });

  return (
    <div
      className="confirm-backdrop"
      onMouseDown={(e) => { if (e.target === e.currentTarget && !busy) onCancel(); }}
    >
      <div
        ref={dialogRef}
        className="confirm-dialog"
        tabIndex={-1}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="confirm-title"
        aria-describedby="confirm-body"
      >
        <h2 id="confirm-title" className="confirm-title">{title}</h2>
        <div id="confirm-body" className="confirm-body">{children}</div>
        <div className="confirm-actions">
          <button ref={cancelRef} type="button" className="btn btn-secondary" onClick={onCancel} disabled={busy}>
            {cancelLabel || t('clients.cancel')}
          </button>
          <button
            type="button"
            className={`btn ${danger ? 'btn-danger' : 'btn-primary'}`}
            onClick={onConfirm}
            disabled={busy}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
